import { render } from "./ProductItemList.vue?vue&type=template&id=01959fc4&ts=true"
import script from "./ProductItemList.vue?vue&type=script&lang=ts"
export * from "./ProductItemList.vue?vue&type=script&lang=ts"

import "./ProductItemList.vue?vue&type=style&index=0&id=01959fc4&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__